export default {
  identify({ name, ...other } = {}) {
    if (window.Intercom) {
      window.Intercom('update', { name, ...other });
    }
  },
  update() {
    if (window.Intercom) {
      window.Intercom('update');
    }
  },
};
